import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { HomeService } from 'src/app/services/home.service';
import { MiradoresService } from 'src/app/services/miradores.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Share } from '@capacitor/share/dist/esm';
import * as moment from 'moment';


import SwiperCore, { Pagination } from "swiper";
import { Recommendation, RecommendationOffer } from 'src/app/models/recommendation';
import { Mirador } from 'src/app/models/mirador';
import { ActionSheetController, InfiniteScrollCustomEvent, ToastController } from '@ionic/angular';
import { Post } from 'src/app/models/post';
import { Timestamp } from 'firebase/firestore';
import { LinkManagerService } from 'src/app/services/link-manager.service';
import { CityRegion } from 'src/app/models/city-region';
import { ExperienceService } from 'src/app/services/experience.service';
import { ListAlbumDetailService } from 'src/app/services/list-album-detail.service';
import { AlbumsService } from 'src/app/services/albums.service';
import { Experience } from 'src/app/models/ToursModels';
import { MMTranslatePipe } from 'src/app/pipes/mmtranslate.pipe';
import { TranslateService } from '@ngx-translate/core';
import { TravelGuidesService } from 'src/app/services/travel-guides.service';
import { TravelGuide } from 'src/app/models/travel-guide.models';
import { MetricsService } from 'src/app/services/metrics.service';

SwiperCore.use([Pagination]);

@Component({
  selector: 'app-start',
  templateUrl: './start.page.html',
  styleUrls: ['./start.page.scss'],
})
export class StartPage implements OnInit, OnDestroy {
  currentSesion: User;
  imageLoaded = false;
  imagesArray = [
    "https://firebasestorage.googleapis.com/v0/b/miradores-ac574.appspot.com/o/DallE%2Fdall-e-encanto.png?alt=media&token=b2b3a794-efba-430a-ac74-e25bdfc6a990",
    "https://firebasestorage.googleapis.com/v0/b/miradores-ac574.appspot.com/o/logo-cover%2FCOVER%20EL%20ENCANTO%200.png?alt=media&token=b0965ebb-bd36-4ff7-aaa3-cf1309a5540b",
    "https://firebasestorage.googleapis.com/v0/b/miradores-ac574.appspot.com/o/logo-cover%2FCOVER%20EL%20ENCANTO%202.png?alt=media&token=62a14ec8-4ced-4cab-a7af-3c0b0413b97b"
  ];
  dailyRecommendationLink = `https://med.miradores.co/app/home`;
  imagesDailyRecommendation = [];

  public miradorRecomended: Mirador = null;
  recommendation: Recommendation | null = null;
  recommendationOffer: RecommendationOffer | null = null;

  postLoaded: boolean = false;
  posts: Post[] = [];


  cityRegionSelected: CityRegion;
  citiesAndRegions: CityRegion[] = [];
  filteredCitiesAndRegions: CityRegion[] = [];
  randomImage: string;
  defaultBackg: string[] = [
    '/assets/sample-images/search-city/1.jpg',
    '/assets/sample-images/search-city/2.jpg',
    '/assets/sample-images/search-city/3.jpg'
  ]
  isModalSearchModalOpen = false;

  isExpanded = false;

  public allMiradores: Mirador[] = [];
  experiences: Experience[] = [];
  allSites: Mirador[] = [];
  miradores: Mirador[] = [];
  rooftops: Mirador[] = [];
  hospedajes: Mirador[] = [];
  mountainRestaurants: Mirador[] = [];
  cityRestaurants: Mirador[] = [];
  premiumHospedajes: Mirador[] = [];

  allTravelGuides: TravelGuide[];

  private unsubscribe$ = new Subject<void>();

  constructor(private MIService: MiradoresService,
    private router: Router,
    public auth: AuthService,
    private homeService: HomeService,
    private toastController: ToastController,
    private linkManager: LinkManagerService,
    public experienceService: ExperienceService,
    public miradoresService: MiradoresService,
    private listAlbumService: ListAlbumDetailService,
    private albumsService: AlbumsService,
    private mmTranslatePipe: MMTranslatePipe,
    public translate: TranslateService,
    public travelGuidesService: TravelGuidesService,
    private actionSheetCtrl: ActionSheetController,
    private metricsService: MetricsService,) { }

  ngOnInit() {
    this.getSession();

    this.experienceService.cityRegionSelectedSubject$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((selected) => {
        if (selected) {
          this.cityRegionSelected = selected;

          this.albumsService.$miradoresLoaded
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((isDone) => {
              console.log(this.cityRegionSelected);
              if (isDone) {
                this.loadMiradoresByCity(this.cityRegionSelected.album_id); // Carga los miradores al iniciar el componente
              }
            })


        }
      });


    this.recommendation = null;
    this.imagesDailyRecommendation = [];
    this.homeService.$dailyRecommendationOfferLoaded
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isDone) => {
        if (isDone) {
          this.recommendationOffer = this.homeService.getDailyRecommendationOffer();
          console.log(this.recommendationOffer);
          this.imagesDailyRecommendation = [];
          this.imagesDailyRecommendation.push(this.recommendationOffer.imageURL);
          /*   switch (this.recommendationOffer.offerType) {
              case 'privateExperience':
                this.loadPrivateExperienceData(this.recommendationOffer.offerId);
                break;
              case 'colectiveExperience':
                this.loadColectiveExperienceData(this.recommendationOffer.offerId);
                break;
              case 'album':
                break;
            } */
        }
      });

    this.citiesAndRegions = this.experienceService.getAllCitiesRegion();
    this.filteredCitiesAndRegions = [...this.citiesAndRegions];
    this.randomImage = this.defaultBackg[Math.floor(Math.random() * this.defaultBackg.length)];


    this.experienceService.$allExperiences
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.experiences = data
          .filter(e => e.experienceType === "PRIVATE_VARIABLE_PRICE_RESERVATION")
          .map(e => {
            return { ...e, urlCovers: this.shuffleArray(e.urlCovers) };
          });
        console.log(this.experiences);
      })


    this.loadTravelGuides();


    this.homeService.$postsLoaded
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isDone) => {
        console.log(isDone);
        if (isDone) {
          this.homeService.$allPosts.subscribe((posts) => {
            this.posts = posts;
            console.log(this.posts);
          })
          this.postLoaded = isDone;
        }
      })

  }

  loadMiradoresByCity(cityId): void {
    this.albumsService.setMiradorsByCity(cityId);
    this.albumsService.getMiradorsByCity()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: miradores => {
          this.allSites = miradores;

          this.rooftops = this.allSites.filter(site =>
            site?.category?.id === 3
          );

          // Filtramos por categoría
          this.miradores = this.allSites.filter(site =>
            [1, 2, 4].includes(site?.category?.id)
          );

          this.hospedajes = this.allSites.filter(site =>
            site?.category?.id === 5
          );

          this.mountainRestaurants = this.allSites.filter(site =>
            Number(site?.category?.id) === 2
          );

          this.premiumHospedajes = this.allSites.filter(site =>
            Number(site?.category?.id) === 6
          );
          console.log(this.premiumHospedajes)

          this.cityRestaurants = this.allSites.filter(site =>
            Number(site?.category?.id) === 7
          );

        },
        error: error => {
          console.error('Error al cargar los miradores:', error);
        }
      }
      );
  }

  loadTravelGuides() {
    this.travelGuidesService.travelGuideByCityRegion$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((travelGuides) => {
        this.allTravelGuides = travelGuides;
        console.log(this.allTravelGuides);
      });
  }



  toggleAnimation() {
    this.isExpanded = !this.isExpanded;
  }

  shuffleArray(array) {
    let shuffledArray = array.slice(); // Hacer una copia del array original
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Intercambiar elementos
    }
    return shuffledArray; // Devolver el array barajado
  }

  openGuide() {

    this.metricsService.logEvent(
      '0',
      'La Guia LeadMagnet',
      'travel_guide',
      'download_free',
      this.currentSesion?.uid || null,
      'app_cover'
    );
    window.open('https://ohmy.link/zrb6ftf', '_blank'); // '_blank' para nueva pestaña, usa '_self' si la quieres en la misma
  }

  loadMiradorData(miradorId: string) {
    this.MIService.$miradoresLoaded
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isDone) => {
        if (isDone) {
          this.miradorRecomended = this.MIService.getMiradorById(miradorId);
          this.imagesDailyRecommendation = this.imagesDailyRecommendation.concat(this.miradorRecomended.covers);
        }
      }).unsubscribe();
  }



  getSession() {
    this.auth.$establishedSession
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(user => {
        this.currentSesion = user;
      })
  }

  getUrlCover(cover) {
    return cover;
    /* return !cover.toLowerCase().startsWith("https://") ? `${IMAGES_PATH}miradores/${cover}` : cover; */
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  generateAndOpenDinamikLink(path) {
    const dinamikLink = this.linkManager.generateDinamicLink(path);
    window.open(dinamikLink, '_self')
  }

  seeViewpoint(miradorRecomended) {
    const miradorNameNormalize = this.MIService.getNormalizedMiradorNameForURL(miradorRecomended.name);
    if (this.linkManager.isMobileWeb()) {
      this.generateAndOpenDinamikLink('mirador/' + miradorNameNormalize);
    } else {
      this.router.navigate(['/mirador', miradorNameNormalize], {
        queryParams: { utm_source: 'app' }
      });
    }
  }




  async createShareNotification(): Promise<void> {

    const toast = await this.toastController.create({
      message: 'Enlace copiado al portapapeles',
      duration: 2000,
      position: 'top',
      color: 'primary'
    });

    await toast.present();

  }

  async onShareLinkClipboard() {
    navigator.clipboard.writeText(this.dailyRecommendationLink)
      .then(() => {
        this.createShareNotification();
      })
      .catch((error) => {
        console.error('Error al copiar al portapapeles: ', error);
      });
  }

  async onShareLink() {
    await Share.share({
      title: 'Compartir experiencia',
      text: this.recommendation?.title,
      url: this.dailyRecommendationLink,
      dialogTitle: 'Miradores Medellín',
    });
  }


  onIonInfinite(ev) {
    console.log("getOtherPosts", (this.homeService.lastDoc?.date as Timestamp)?.toDate())
    this.homeService.getPostLazyLoad();
    let postLoadedSubs = this.homeService.$postsLoaded
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (isDone) => {
        if (isDone) {
          (ev as InfiniteScrollCustomEvent).target.complete();
        } else {
          const toast = await this.toastController.create({
            message: 'Estas al dia',
            duration: 2000,
            position: 'bottom',
            color: 'primary'
          });

          await toast.present();
          (ev as InfiniteScrollCustomEvent).target.complete();
        }
        postLoadedSubs.unsubscribe();
      });
  }

  handleRefresh(event) {
    console.log('Iniciando operación de refresco');

    const todayStart = moment().startOf('day').toDate();
    const todayEnd = moment().endOf('day').toDate();

    this.homeService.loadDailyRecommendation(todayStart, todayEnd);

    let dailyRecommendationLoadedSubs;
    dailyRecommendationLoadedSubs = this.homeService.$dailyRecommendationLoaded
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isDone) => {
        console.log({ isDone });
        event.target.complete(); // Finaliza la acción de refresco

        if (dailyRecommendationLoadedSubs) { // Verifica si la suscripción está definida antes de intentar desuscribirse
          dailyRecommendationLoadedSubs.unsubscribe();
        }
      });

    this.homeService.restartLazyLoad();
  }

  GoToTravelGuideOverview(travelGuide: TravelGuide) {
    this.router.navigate(['/guide-includes'], {
      state: { guide: travelGuide }
    });
  }

  GoToExperienceDetail(exp: Experience) {
    this.router.navigate(['/experience', exp._id], {
      queryParams: { utm_source: 'app' }
    });
  }

  async presentGuideOptions(travelGuide: TravelGuide) {
    const yaDescargoGratis = localStorage.getItem('guiaGratuitaDescargada') === 'true';

    const textoBoton = yaDescargoGratis
      ? 'Comprar Guía $6 USD'
      : 'Descargar Gratis (Luego $6) 🎁';

    const handlerBoton = () => {
      if (yaDescargoGratis) {

        this.metricsService.logEvent(
          travelGuide._id,
          travelGuide.name,
          'travel_guide',
          'purchase_click',
          this.currentSesion?.uid || null,
          'app_action_sheet'
        );

        // Redirigir a WhatsApp con el ID de la guía
        const mensaje = encodeURIComponent(`Hola, quiero comprar la guía con ID: ${travelGuide._id}`);
        const url = `https://wa.me/573117806578?text=${mensaje}`;
        window.open(url, '_blank');
      } else {

        this.metricsService.logEvent(
          travelGuide._id,
          travelGuide.name,
          'travel_guide',
          'download_free',
          this.currentSesion?.uid || null,
          'app_action_sheet'
        );
        // Descargar guía gratuita y guardar en localStorage
        localStorage.setItem('guiaGratuitaDescargada', 'true');
        window.open('https://firebasestorage.googleapis.com/v0/b/miradores-ac574.appspot.com/o/guia%2FGuiaDeViajeMed8D-PrimeraVez.pdf?alt=media&token=ab2871d2-6988-4f4b-9fdd-a8cfca798af0', '_blank'); // Asegúrate que travelGuide.pdfUrl tenga el link al PDF
      }
    };

    const actionSheet = await this.actionSheetCtrl.create({
      header: '¿Qué deseas hacer?',
      buttons: [
        {
          text: '¿Qué incluye esta guía?',
          icon: 'information-circle-outline',
          handler: () => {
            this.router.navigate(['/guide-includes'], {
              state: { guide: travelGuide }
            });
          }
        },
        {
          text: textoBoton,
          icon: 'cart-outline',
          handler: handlerBoton
        },
        {
          text: 'Cancelar',
          role: 'cancel',
          icon: 'close-outline'
        }
      ]
    });

    await actionSheet.present();
  }


  startWhatsappCheckout(travelGuide: any) {
    const audienceMap = {
      solo: 'Viajando solo(a)',
      family: 'En familia',
      friends: 'Con amigos',
      couple: 'En pareja'
    };

    const message = encodeURIComponent(
      `¡Hola! Me interesa comprar esta guía de viaje.\n\n` +
      `Tipo de público: ${audienceMap[travelGuide.targetAudience] || 'N/A'}\n` +
      `Número de días: ${travelGuide.numberOfDays}\n` +
      `ID de la guía: ${travelGuide._id || 'sin ID'}`
    );

    const whatsappUrl = `https://wa.me/573117806578?text=${message}`;
    window.open(whatsappUrl, '_blank');
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
